<template>
  <section class="section3 d-flex align-items-center" ref="sectionRef">
    <div class="container-fluid px-5">
      <!-- Titre -->
      <h2
        class="text-center fw-bold mb-3"
        :class="{ 'animated slide-left delay-0': isVisible }"
      >
        <span class="badge bg-primary fs-2">
          Solutions basées sur le Web
        </span>
      </h2>

      <!-- Badge -->
      <div
        class="text-center mb-4"
        :class="{ 'animated slide-left delay-1': isVisible }"
      >
        <span class="badge bg-primary fs-2">
          Portail Web Universel / Service Clientèle D'entreprise
        </span>
      </div>

      <!-- Image + Cards -->
      <div class="row align-items-center">
        <!-- Image à gauche -->
        <div class="col-lg-6 mb-4 mb-lg-0 text-center">
          <img
            src="@/assets/section3-image.png"
            alt="Web Solutions"
            class="img-fluid rounded"
            :class="{ 'animated slide-left delay-2': isVisible }"
          />
        </div>

        <!-- Cartes à droite -->
        <div class="col-lg-6">
          <div class="row g-3">
            <div
              class="col-12"
              :class="{ 'animated slide-right delay-0': isVisible }"
            >
              <div class="card shadow border-0 border-bottom border-primary border-4 h-100 card-animate">
                <div class="card-body">
                  <h3 class="card-title fw-bold">Présentation générale</h3>
                  <p class="card-text">
                    Il s'agit d'un service de rechargement direct pris en charge par tous les réseaux ;<br />
                    Il s'agit d'un portail Web qui permet aux entreprises de gérer facilement leur consommation de temps d'antenne.
                  </p>
                </div>
              </div>
            </div>

            <div
              class="col-12"
              :class="{ 'animated slide-right delay-1': isVisible }"
            >
              <div class="card shadow border-0 border-bottom border-primary border-4 h-100 card-animate">
                <div class="card-body">
                  <h3 class="card-title fw-bold">Usage</h3>
                  <p class="card-text">
                    L'organisation distribue le temps d'antenne à partir du porte-monnaie ;<br />
                    Les utilisateurs peuvent recharger au coup par coup ou en masse, visualiser, tirer et exporter des rapports.
                  </p>
                </div>
              </div>
            </div>

            <div
              class="col-12"
              :class="{ 'animated slide-right delay-2': isVisible }"
            >
              <div class="card shadow border-0 border-bottom border-primary border-4 h-100 card-animate">
                <div class="card-body">
                  <h3 class="card-title fw-bold">Marché cible</h3>
                  <p class="card-text">
                    Les entreprises, comme les banques, peuvent utiliser le service de recharge pour leur personnel avec une ligne mobile prépayée.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useInView } from '@/composables/useInView.js'

export default {
  name: 'Section3View',
  setup() {
    const { isVisible, target: sectionRef } = useInView({
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    })
    return { isVisible, sectionRef }
  }
}
</script>

<style scoped>
.section3 {
  min-height: 100vh;
  padding: 4rem 0;
  font-family: 'Public Sans', sans-serif;
  background-color: #f7f9fb;
}

.section3 img {
  max-width: 100%;
  width: 90%;
  height: auto;
  object-fit: cover;
}

/* Styles des cartes avec animation */
.card-animate {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease-out;
}

.card {
  transition: all 0.3s ease;
  background-color: #f1f4f9;
}

.card:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

/* Animation quand la section est visible */
.animated.slide-right ~ .col-lg-6 .card-animate,
.animated.slide-left ~ .row .card-animate {
  opacity: 1;
  transform: translateY(0);
}

/* === ANIMATIONS PRINCIPALES === */
.animated {
  opacity: 0;
  animation-fill-mode: forwards;
}

.slide-left {
  transform: translateX(-120px);
  animation: slideInLeft 1s cubic-bezier(0.65, 0, 0.35, 1.5) forwards;
}

.slide-right {
  transform: translateX(120px);
  animation: slideInRight 1s cubic-bezier(0.65, 0, 0.35, 1.5) forwards;
}

@keyframes slideInLeft {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Délais d'animation */
.delay-0 { animation-delay: 0.4s; }
.delay-1 { animation-delay: 0.6s; }
.delay-2 { animation-delay: 0.9s; }
.delay-3 { animation-delay: 1.2s; }

/* Animation du badge */
.badge {
  display: inline-block;
  transition: all 0.5s ease;
}

.animated.slide-left .badge {
  animation: pulse 1s ease 0.6s 1;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Responsive */
@media (max-width: 991px) {
  .section3 {
    padding: 2rem 0;
  }
  .section3 img {
    margin-bottom: 2rem;
  }
  .slide-left, .slide-right {
    animation-duration: 0.8s;
  }
}
</style>